import {
  Statistics,
  Calendar,
  CandleStick,
  Globus,
  Book,
  User,
  GlobalLine,
  Home,
  CalendarCheck,
  StarMedal,
  Info,
  HandCoin,
  Heart,
  Filter,
  SunCheck,
  InfoOutline,
  ArrowRightSpace,
  InformationFill,
  ArrowRightSpaceSecondary,
  Close,
  ChevronDown,
  StarSolid,
  ArrowDownSolid,
  Eye,
  EyeClosed,
  LogoWithText,
  Menu,
  File,
  ExclamationMarkCircle,
  Logo,
  ArrowLeftLine,
  Wallet,
  Flag,
  Star,
  ArrowRight,
  CloseCircleFill,
  CheckCircleFill,
  Plus,
  EditLine,
  DeleteBinLine,
  CheckMark,
  WarningTriangle,
  DiscountMedal,
  BankCardFill,
  ArrowLeftLineShort,
  Marketing,
  TimeFill,
  Mail,
  PlusCircle,
  MinusCircle,
  Lightning,
  CalendarLine,
  PushpinFill,
  SwapBoxFill,
} from './icons'
import AlertIcon from './icons/Alert'
import InfoIcon from './icons/InfoIcon'

const icons = {
  statistics: Statistics,
  calendar: Calendar,
  candlestick: CandleStick,
  globus: Globus,
  book: Book,
  user: User,
  'global-line': GlobalLine,
  home: Home,
  'calendar-check': CalendarCheck,
  'star-medal': StarMedal,
  info: Info,
  'hand-coin': HandCoin,
  heart: Heart,
  filter: Filter,
  'sun-check': SunCheck,
  'info-outline': InfoOutline,
  'arrow-right-space': ArrowRightSpace,
  'information-fill': InformationFill,
  'arrow-right-space-secondary': ArrowRightSpaceSecondary,
  close: Close,
  'chevron-down': ChevronDown,
  'star-solid': StarSolid,
  'arrow-down-solid': ArrowDownSolid,
  'eye-closed': EyeClosed,
  eye: Eye,
  'logo-with-text': LogoWithText,
  menu: Menu,
  file: File,
  'exclamation-mark-circle': ExclamationMarkCircle,
  logo: Logo,
  'arrow-left-line': ArrowLeftLine,
  wallet: Wallet,
  flag: Flag,
  star: Star,
  'arrow-right': ArrowRight,
  'close-circle-fill': CloseCircleFill,
  'check-circle-fill': CheckCircleFill,
  plus: Plus,
  'edit-line': EditLine,
  'delete-bin-line': DeleteBinLine,
  'check-mark': CheckMark,
  'warning-triangle': WarningTriangle,
  'discount-medal': DiscountMedal,
  'bank-card-fill': BankCardFill,
  'arrow-left-line-short': ArrowLeftLineShort,
  marketing: Marketing,
  'time-fill': TimeFill,
  mail: Mail,
  'plus-circle': PlusCircle,
  'minus-circle': MinusCircle,
  lightning: Lightning,
  'calendar-line': CalendarLine,
  'pushpin-fill': PushpinFill,
  'swap-box-fill': SwapBoxFill,
  'info-icon': InfoIcon,
  alert: AlertIcon,
}

const Icon = ({ name, ...props }) => {
  const IconComponent = icons[name]

  if (!IconComponent) {
    return null
  }

  return <IconComponent {...props} />
}

export default Icon
